import React from 'react';
import { AccountSettingsBase } from './account-settings.base';

export const AccountSettingsClosed = () => <AccountSettingsBase />;
